@use '~/theme/theme' as *;

.container {
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  align-items: center;
  padding: 0 spacing(3);

  [role='tablist'] {
    margin: 0;
  }

  > * {
    flex-shrink: 0;
  }
}
